// extracted by mini-css-extract-plugin
export default {"textButton":"ImportOIDC_textButton__N+J3e","error":"ImportOIDC_error__eOI3R"};